module.exports = __webpack_public_path__ + "img/logo.bf02df79.png";